import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './content-list6.css'

const ContentList6 = (props) => {
  const [isPrivacyVisible, setIsPrivacyVisible] = useState(false)
  const [isTermsVisible, setIsTermsVisible] = useState(true)
  const [isRefundVisible, setIsRefundVisible] = useState(false)
  return (
    <div className="content-list6-container1 thq-section-padding">
      <div className="content-list6-max-width thq-section-max-width">
        <div className="content-list6-container2 thq-flex-column">
          {isTermsVisible === true && (
            <div className="content-list6-container3">
              <ul className="content-list6-ul1 thq-flex-column">
                <li className="content-list6-li10 list-item thq-flex-column">
                  <h2 className="content-list6-heading7 thq-heading-2">
                    {props.heading7 ?? (
                      <Fragment>
                        <span className="content-list6-text24">
                          Allstream Global DEI Policy Statement
                        </span>
                      </Fragment>
                    )}
                  </h2>
                  <ul className="content-list6-ul2 thq-flex-column">
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading8 ?? (
                          <Fragment>
                            <span className="content-list6-text30">
                              1. Purpose &amp; Scope
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content2 ?? (
                          <Fragment>
                            <span className="content-list6-text31">
                              At Allstream Global, we are committed to building
                              an inclusive and equitable workplace that respects
                              and values diverse backgrounds and perspectives.
                              This policy applies to all employees, partners,
                              clients, and vendors.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading87 ?? (
                          <Fragment>
                            <span className="content-list6-text38">
                              2. Definitions
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content27 ?? (
                          <Fragment>
                            <span className="content-list6-text14">
                              <span className="content-list6-text15">
                                Diversity:
                              </span>
                              <span>
                                {' '}
                                Representation across race, gender, age,
                                nationality, abilities, and more.
                              </span>
                              <br></br>
                              <span className="content-list6-text18">
                                Equity:
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: ' ',
                                  }}
                                />
                              </span>
                              <span>
                                Ensuring fair access, opportunity, and
                                advancement for all.
                              </span>
                              <br></br>
                              <span className="content-list6-text21">
                                Inclusion:
                              </span>
                              <span>
                                {' '}
                                Creating a culture where all individuals feel
                                respected, accepted, and valued.
                              </span>
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading86 ?? (
                          <Fragment>
                            <span className="content-list6-text35">
                              3. Our Commitment
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content26 ?? (
                          <Fragment>
                            <span className="content-list6-text10">
                              We hire, develop, and promote based on merit. We
                              maintain a zero-tolerance stance toward
                              discrimination and bias. Our leadership team
                              reflects our commitment to diversity, with 45% of
                              roles held by women.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading85 ?? (
                          <Fragment>
                            <span className="content-list6-text28">
                              4. Recruitment &amp; Hiring Practices
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content25 ?? (
                          <Fragment>
                            <span className="content-list6-text26">
                              We utilize structured interviews, inclusive job
                              descriptions, and ensure diverse hiring panels. We
                              proactively seek candidates from underrepresented
                              groups.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading84 ?? (
                          <Fragment>
                            <span className="content-list6-text11">
                              <span>5. Training &amp; Education</span>
                              <br></br>
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content24 ?? (
                          <Fragment>
                            <span className="content-list6-text27">
                              We require all employees to undergo unconscious
                              bias training, and managers receive additional
                              training in inclusive leadership and equitable
                              evaluations.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading83 ?? (
                          <Fragment>
                            <span className="content-list6-text25">
                              6. Zero Tolerance for Discrimination
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content23 ?? (
                          <Fragment>
                            <span className="content-list6-text33">
                              We provide clear grievance procedures and protect
                              individuals who raise concerns. Violations are met
                              with strict consequences.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading82 ?? (
                          <Fragment>
                            <span className="content-list6-text32">
                              7. Accountability &amp; Monitoring
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content22 ?? (
                          <Fragment>
                            <span className="content-list6-text34">
                              We collect and monitor DEI metrics annually and
                              embed diversity goals into leadership evaluations.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading81 ?? (
                          <Fragment>
                            <span className="content-list6-text37">
                              8. Supplier &amp; Community Engagement
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content21 ?? (
                          <Fragment>
                            <span className="content-list6-text36">
                              We expect our suppliers and vendors to align with
                              our DEI standards and support local initiatives
                              promoting inclusion.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                    <li className="list-item">
                      <h3 className="thq-heading-3">
                        {props.heading9 ?? (
                          <Fragment>
                            <span className="content-list6-text29">
                              9. Review &amp; Updates
                            </span>
                          </Fragment>
                        )}
                      </h3>
                      <p className="thq-body-small">
                        {props.content9 ?? (
                          <Fragment>
                            <span className="content-list6-text23">
                              This policy is reviewed annually by our DEI
                              committee and updated as needed to reflect current
                              best practices.
                            </span>
                          </Fragment>
                        )}
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ContentList6.defaultProps = {
  content26: undefined,
  heading84: undefined,
  content27: undefined,
  content9: undefined,
  heading7: undefined,
  heading83: undefined,
  content25: undefined,
  content24: undefined,
  heading85: undefined,
  heading9: undefined,
  heading8: undefined,
  content2: undefined,
  heading82: undefined,
  content23: undefined,
  content22: undefined,
  heading86: undefined,
  content21: undefined,
  heading81: undefined,
  heading87: undefined,
}

ContentList6.propTypes = {
  content26: PropTypes.element,
  heading84: PropTypes.element,
  content27: PropTypes.element,
  content9: PropTypes.element,
  heading7: PropTypes.element,
  heading83: PropTypes.element,
  content25: PropTypes.element,
  content24: PropTypes.element,
  heading85: PropTypes.element,
  heading9: PropTypes.element,
  heading8: PropTypes.element,
  content2: PropTypes.element,
  heading82: PropTypes.element,
  content23: PropTypes.element,
  content22: PropTypes.element,
  heading86: PropTypes.element,
  content21: PropTypes.element,
  heading81: PropTypes.element,
  heading87: PropTypes.element,
}

export default ContentList6
